import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";
import { FunctionComponent } from "react";

export const PersonWithPenIcon: FunctionComponent = ({
  width = "24",
  height = "24",
  color = "#1C3C6C",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 20H15.375L21.0563 14.9375C21.225 14.7688 21.3518 14.5764 21.4365 14.3604C21.5212 14.1444 21.5632 13.9336 21.5625 13.7281C21.5618 13.5226 21.5149 13.3213 21.4219 13.124C21.3289 12.9268 21.207 12.7437 21.0563 12.575L20.0438 11.5062C19.875 11.3375 19.6875 11.2111 19.4813 11.1271C19.275 11.0431 19.0594 11.0008 18.8344 11C18.6281 11 18.4174 11.0424 18.2021 11.1271C17.9869 11.2119 17.7945 11.3382 17.625 11.5062L12 17.1313V20ZM13.6875 18.875V17.8062L16.5281 14.9656L17.0906 15.4719L17.5969 16.0344L14.7563 18.875H13.6875ZM17.0906 15.4719L17.5969 16.0344L16.5281 14.9656L17.0906 15.4719Z"
          fill={color}
        />
        <path
          d="M4 18V17.35C4 17.01 4.16 16.69 4.41 16.54C6.1 15.53 8.03 15 10 15C10.03 15 10.05 15 10.08 15.01C10.18 14.31 10.38 13.64 10.67 13.03C10.45 13.01 10.23 13 10 13C7.58 13 5.32 13.67 3.39 14.82C2.51 15.34 2 16.32 2 17.35V20H11.26C10.84 19.4 10.51 18.72 10.29 18H4ZM10 12C12.21 12 14 10.21 14 8C14 5.79 12.21 4 10 4C7.79 4 6 5.79 6 8C6 10.21 7.79 12 10 12ZM10 6C11.1 6 12 6.9 12 8C12 9.1 11.1 10 10 10C8.9 10 8 9.1 8 8C8 6.9 8.9 6 10 6Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
